import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CachedValuesService } from '@services/index';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementSharedInformationForm } from '../../shared-agreement.model';
import { BaseHighlightComponent } from '@shared/components/base-highlight';

@UntilDestroy()
@Component({
    selector: 'app-general-attributes',
    templateUrl: './general-attributes.component.html',
    styleUrls: ['./general-attributes.component.scss']
})
export class GeneralAttributesComponent extends BaseHighlightComponent implements OnInit, OnDestroy {
    @Input() public detailsForm: FormGroup<AgreementSharedInformationForm>;
    @Input() public showPotentialValidationMessages: boolean;
    private readonly cachedValuesService = inject(CachedValuesService);

    public agreementTypeName = '';
    public showPartsInfo = false;
    public get f() {
        return this.detailsForm.controls;
    }

    public override ngOnInit() {
        super.ngOnInit();
        this.cachedValuesService.agreementTypes$.subscribe((response) => {
            this.agreementTypeName = response.find((p) => p.name == this.f.agreementTypeId.value.toString()).value;
        });
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
    }

    public get disabled() {
        return this.f.area.disabled;
    }
}
